import type { CargoUI } from '../../../domain';

export const initialStateCargoUI: CargoUI = {
  isOpen: false,
  status: 'idle',
  cancelOrderDialog: { isOpen: false, orderId: 0 },
  isDropDownOpen: false,
};
